import React, { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import styled from 'styled-components';
import { api } from '../services/api';

const Container = styled.div`
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #f8fafc;
  padding: 2rem;
`;

const Card = styled.div`
  background: white;
  border-radius: 16px;
  padding: 2.5rem;
  max-width: 480px;
  width: 100%;
  text-align: center;
  box-shadow: 0 20px 50px rgba(15, 23, 42, 0.1);
`;

const Title = styled.h1`
  font-size: 1.6rem;
  font-weight: 700;
  color: #0f172a;
  margin-bottom: 0.5rem;
`;

const Message = styled.p`
  color: #475569;
  margin-bottom: 1.5rem;
  line-height: 1.6;
`;

const Button = styled.button`
  background: #ef4444;
  color: white;
  border: none;
  padding: 0.75rem 1.5rem;
  border-radius: 10px;
  font-weight: 700;
  cursor: pointer;
`;

export const UnsubscribePage: React.FC = () => {
  const [searchParams] = useSearchParams();
  const [email, setEmail] = useState('');
  const [status, setStatus] = useState<'idle' | 'done' | 'error'>('idle');

  useEffect(() => {
    setEmail(searchParams.get('email') || '');
  }, [searchParams]);

  const handleUnsubscribe = async () => {
    try {
      await api.post('/crm/unsubscribe', { email, channel: 'email' });
      setStatus('done');
    } catch {
      setStatus('error');
    }
  };

  return (
    <Container>
      <Card>
        <Title>Cancelar Emails</Title>
        {status === 'done' ? (
          <Message>Voce foi descadastrado com sucesso.</Message>
        ) : (
          <>
            <Message>
              {email ? `Confirmar descadastro para ${email}?` : 'Confirmar descadastro deste email?'}
            </Message>
            <Button onClick={handleUnsubscribe}>Descadastrar</Button>
          </>
        )}
        {status === 'error' && <Message>Falha ao descadastrar. Tente novamente.</Message>}
      </Card>
    </Container>
  );
};
